<lib-dialog
  [title]="'agb-to-accept-dialog.text.agb' | translate"
  [isLoading]="isLoading"
  [hideCloseButtonIcon]="true"
  [displayActionContainerAsColumnOnMobile]="true"
>
  <div *ngIf="agb" body [innerHTML]="agb.content"></div>

  <ng-container action>
    <button mat-button color="warn" [disabled]="isLoading" (click)="deny()">
      {{ 'agb-to-accept-dialog.buttons.deny-and-logout' | translate }}
    </button>

    <button
      mat-flat-button
      color="primary"
      [disabled]="isLoading"
      (click)="submit()"
    >
      {{ 'agb-to-accept-dialog.buttons.agree' | translate }}
    </button>
  </ng-container>
</lib-dialog>
